"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const activities_1 = require("../../api/activities");
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const configuration_1 = __importDefault(require("../apis/configuration/activities/configuration"));
class ReturnStore {
    selectedReturnIds = [];
    loading = false;
    api = new activities_1.RmaApi(configuration_1.default);
    validationErrors = {};
    errorCodes = {};
    internalReturns = [];
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            internalReturns: mobx_1.observable,
            loading: mobx_1.observable,
            validationErrors: mobx_1.observable,
            selectedReturnIds: mobx_1.observable,
            errorCodes: mobx_1.observable,
            setProperty: mobx_1.action,
            setErrorCode: mobx_1.action,
            setErrors: mobx_1.action,
        });
    }
    get isLoading() {
        return this.loading;
    }
    get totalReturns() {
        return this.selectedReturnIds.length;
    }
    get selectedRmas() {
        return this.selectedReturnIds.reduce((result, selectedId) => {
            const matchingRma = this.internalReturns.find((rma) => rma.id === selectedId);
            if (matchingRma) {
                result[selectedId] = matchingRma;
            }
            return result;
        }, {});
    }
    get returns() {
        return this.internalReturns;
    }
    toggleReturn(objectID) {
        const isSelected = this.selectedReturnIds.some((value) => value === objectID);
        if (isSelected) {
            this.selectedReturnIds = this.selectedReturnIds.filter((value) => value !== objectID);
        }
        else {
            this.selectedReturnIds = [...this.selectedReturnIds, objectID];
        }
    }
    isSelectedReturn(objectID) {
        return this.selectedReturnIds.indexOf(objectID) !== -1;
    }
    readReturns() {
        if (!AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.RETURN_READ) || this.loading) {
            return Promise.resolve(this.internalReturns);
        }
        this.loading = true;
        return this.api
            .getRma()
            .then((0, mobx_1.action)((returns) => (this.internalReturns = returns)))
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
    get hasSelectedReturns() {
        return this.selectedReturnIds.length > 0;
    }
    setProperty(objectId, property, value) {
        const object = this.internalReturns.find((rma) => rma.id === objectId);
        if (object) {
            if ('returnReason' === property) {
                object['returnReason'] = Number(value);
                object['returnReasonOther'] = '';
            }
            else {
                object[property] = value;
            }
            if (this.validationErrors[objectId]?.[property]) {
                delete this.validationErrors[objectId]?.[property];
            }
            this.internalReturns = this.internalReturns.map((rma) => (rma.id === objectId ? object : rma));
        }
    }
    setErrorCode(objectId, errorCode) {
        this.errorCodes[objectId] = errorCode;
    }
    putRma(object) {
        return this.api.putRma({ id: object.id, rma: { ...object, isInReturnProcess: true } });
    }
    getReturnReasonOptions() {
        return Object.keys(activities_1.RmaReturnReasonEnum).map((key) => ({
            value: String(activities_1.RmaReturnReasonEnum[key]),
            label: (0, translation_1.t)('myassets.returns.table.select_return_reason', {
                returnReason: activities_1.RmaReturnReasonEnum[key],
            }),
        }));
    }
    setErrors(objectId) {
        const rmaData = this.selectedRmas[objectId];
        const { serialNumber, machineNumber, returnReason, returnReasonOther } = rmaData || {};
        const rmaErrors = {};
        if (!serialNumber || serialNumber.trim() === '') {
            rmaErrors.serialNumber = 'Serial number is required.';
        }
        if (!machineNumber || machineNumber.trim() === '') {
            rmaErrors.machineNumber = 'Machine number is required.';
        }
        if (!returnReason && AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.RETURN_REASON_UPDATE)) {
            rmaErrors.returnReason = 'Return reason is required.';
        }
        if ((!returnReasonOther || returnReasonOther.trim() === '') &&
            rmaData.returnReason === activities_1.RmaReturnReasonEnum.NUMBER_4 &&
            AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.RETURN_REASON_UPDATE)) {
            rmaErrors.returnReasonOther = 'Return reason is required.';
        }
        this.validationErrors = { ...this.validationErrors, [objectId]: rmaErrors };
    }
    rmaHasErrors(objectId) {
        return Object.keys(this.validationErrors[objectId]).length === 0;
    }
    isValid() {
        for (const id in this.validationErrors) {
            if (!this.rmaHasErrors(id)) {
                return false;
            }
        }
        return true;
    }
    getValidationError(objectId, field) {
        return this.validationErrors[objectId]?.[field];
    }
    clearSelectedReturns() {
        this.selectedReturnIds = [];
    }
}
exports.default = new ReturnStore();
